import type { ReactNode } from 'react';

export function NerdyTipCallout({ children }: { children: ReactNode }) {
  if (!children) return null;

  return (
    <div
      className="bg-[var(--content-yellow-lightest)] border-t-4 border-primary p-6 md:p-[36px]"
      data-testid="page-nerdy-tip"
    >
      <div className="flex items-center gap-4 mb-1">
        <span className="typography-text-large-bold">🤓</span>
        <p className="typography-text-bold">Nerdy Tip</p>
      </div>
      {children}
    </div>
  );
}
